'use strict';

(function () {
    const sidhuvud = document.querySelector('.sidhuvud');
    const meny = document.querySelector('#fastighet-meny');
    const menyLankar = document.querySelector('.meny-lankar');
    const toggler = document.querySelector('#navbar-fastighet-meny .navbar-toggler');
    const togglerSticky = document.querySelector('.container-sticky .navbar-toggler');
    const toggleLank = document.querySelector('#navbar-fastighet-meny .nav-link-active');
    const toggleStangLank = document.querySelector('#navbar-fastighet-meny .nav-link-stang');
    const livlinemeny = document.querySelector('#navbar-livlina-meny');
    const sidhuvudSticky = document.querySelector('.container-sticky');
    const snabbfaktamobil = 'snabb-fakta-mobil';
    const sidhuvudContainer = document.querySelector('.sidhuvud-container');
    const temaDark = 'navbar-dark';
    const temaLight = 'navbar-light';

    let map, marker;
    let markers = [];

    af.setHeightInPercentForMobile();
    if (document.getElementById('map')) {
        kartor.initieraKarta(initMap);
    }
    uppdateraSidhuvudVidScroll();
    hanteraToggleKlick();
    hanteraMenyUtfalld();
    hanteraFastighetMenyUtfalld();
    hanteraResize();

    function uppdateraSidhuvudVidScroll() {
        if ('IntersectionObserver' in window) {
            const sidhuvudObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        deaktiveraStickyMeny();
                    } else {
                        aktiveraStickyMeny();

                    }
                })
            }, {
                rootMargin: '-5% 0% -95% 0%'
            });
            sidhuvudObserver.observe(sidhuvud);
        }

        function aktiveraStickyMeny() {
            sidhuvud.classList.add('sticky');
            doljMeny();
        }

        function deaktiveraStickyMeny() {
            sidhuvud.classList.remove('sticky');
            doljMeny();
        }
    }

    function hanteraToggleKlick() {
        toggler.addEventListener('click', function () {
            doljVisaElement();
        });

        togglerSticky.addEventListener('click', function () {
            doljVisaElement();
        });

        toggleLank.addEventListener('click', function () {
            toggler.click();
        });

        toggleStangLank.addEventListener('click', function () {
            toggler.click();
        });

        menyLankar.addEventListener('click', function (e) {
            const hash = e.target.href.split('#')[1];
            toggler.click();
            setTimeout(function () {
                livlinemeny.classList.remove(temaLight, temaDark);
                livlinemeny.classList.add(temaLight);
                location.hash = hash;
            }, 500);
        });
    }

    function doljVisaElement() {
        toggler.classList.toggle('d-none');
        togglerSticky.classList.toggle('d-none');
    }

    function doljMeny() {
        meny.classList.remove('show');
        toggler.classList.remove('d-none');
    }

    function hanteraMenyUtfalld() {
        $('.livlina').on('show.bs.collapse', function (e) {
            if (e.target.id !== snabbfaktamobil) {
                gomFastighetMeny();
            }
        }).on('hide.bs.collapse', function (e) {
            if (e.target.id !== snabbfaktamobil) {
                if (!meny.classList.contains('show')) {
                    sidhuvudContainer.classList.remove('d-none');
                    toggler.classList.remove('d-none');
                    sidhuvudSticky.classList.remove('d-none');
                    togglerSticky.classList.remove('d-none');
                }
            }
        });
    }

    function hanteraFastighetMenyUtfalld() {
        let aktivtTema = '';
        $('#fastighet-meny').on('show.bs.collapse', function (e) {
            if (e.target.id !== snabbfaktamobil) {
                aktivtTema = hamtaAktivTema();
                livlinemeny.classList.remove(temaDark, temaLight);
                livlinemeny.classList.add(temaDark);
                sidhuvudContainer.classList.add('d-none');
                af.removeHeightInPercentForMobile();
                af.removeScrollPosition(location.pathname);
            }
        }).on('hide.bs.collapse', function (e) {
            if (e.target.id !== snabbfaktamobil) {
                if (!sidhuvud.classList.contains('sticky')) {
                    livlinemeny.classList.remove(temaLight, temaDark);
                    livlinemeny.classList.add(aktivtTema);
                    sidhuvudContainer.classList.remove('d-none');
                }
            }
        }).on('hidden.bs.collapse', function (e) {
            if (e.target.id !== snabbfaktamobil) {
                if (sidhuvud.classList.contains('sticky')) {
                    livlinemeny.classList.remove(temaLight, temaDark);
                    livlinemeny.classList.add(aktivtTema);
                    sidhuvudContainer.classList.remove('d-none');
                }
            }
        });
    }

    function hamtaAktivTema() {
        return livlinemeny.classList.contains(temaDark) ? temaDark : temaLight;
    }

    function gomFastighetMeny() {
        togglerSticky.classList.add('d-none');
        sidhuvudSticky.classList.remove('d-none');
        sidhuvudContainer.classList.add('d-none');
        toggler.classList.add('d-none');

    }

    function hanteraAfterMedgivande() {
        var openTagetAfterReload = sessionStorage.getItem('opentargetafterreload');
        if (openTagetAfterReload) {
            const targetElement = document.querySelector(openTagetAfterReload);
            targetElement.click();
            sessionStorage.removeItem('opentargetafterreload');
        }
    }

    function initMap() {

        const karta = document.getElementById('map');
        const adress = document.getElementById('fastighet-adress').value;
        const latitud = document.getElementById('fastighet-latitud').value;
        const longitud = document.getElementById('fastighet-longitud').value;
        const ovrigaAdresser = document.querySelectorAll('[id^="ovrig-fastighet-adress-"]');
        const ovrigaLatitud = document.querySelectorAll('[id^="ovrig-fastighet-latitud-"]');
        const ovrigaLongitud = document.querySelectorAll('[id^="ovrig-fastighet-longitud-"]');

        map = kartor.skapaKarta(karta, latitud, longitud);
        markeraFastighet(adress, latitud, longitud, true);

        for (var i = 0; i < ovrigaAdresser.length; i++) {
            markeraFastighet(ovrigaAdresser[i].value, ovrigaLatitud[i].value, ovrigaLongitud[i].value, false);
        }
        hanteraAfterMedgivande();

    }

    function markeraFastighet(adress, latitud, longitud, mainMarker) {

        const fastighet = document.querySelector('[data-adress="' + adress + '"][data-latitud="' + latitud + '"][data-longitud="' + longitud + '"].card-fastighet');
        const popup = kartor.skapaPopupHtmlFranObjekt(fastighet);

        let ikon = kartor.ikonFastighetSekundar;
        if (mainMarker) {
            ikon = kartor.ikonFastighetPrimar;
        }
        if (latitud !== '' && longitud !== '') {
            marker = kartor.marker(latitud, longitud, map, ikon);
            markers.push(marker);
            kartor.hanteraPopup(map, marker, popup);
        }
    }

    function hanteraResize() {
        window.addEventListener('resize', resizeFunctions);
        if (document.getElementById('felanmalan') !== null) {
            document.getElementById('felanmalan').addEventListener('focusin', resizeFunctions);
        }
    }

    function resizeFunctions() {
        af.setHeightInPercentForMobile();
    }

})();
